import { completeTypes, createTypes, withPostSuccess, withPostFailure } from 'redux-recompose';
import { push } from 'connected-react-router';
import posthog from 'posthog-js';

import { ROUTES } from '~constants/routes';
import FirebaseService from '~services/Firebase/service';
import LocalStorage from '~services/LocalStorageService';
import { setTokenHeader, getTenantId } from '~config/api';
import AdminUserActions from '~redux/AdminUser/actions';

import { TARGETS, MISSING_TENANT_ID } from './constants';

export const actions = createTypes(
  completeTypes(['SIGN_IN_WITH_EMAIL_AND_PASSWORD', 'REFRESH_FIREBASE_TOKEN'], ['SET_VALUE']),
  '@@AUTH'
);

export const actionCreators = {
  signInWithFirebase: (data) => (dispatch, getState) => {
    const store = getState();
    const { tenant, gcpTenantId } = store.core;
    const tenantId = gcpTenantId || getTenantId(tenant);
    // Without a tenantId Firebase signs in against the project's pool, not the company's.
    if (!tenantId) {
      return dispatch({
        type: actions.SIGN_IN_WITH_EMAIL_AND_PASSWORD_FAILURE,
        target: TARGETS.SIGN_IN_WITH_EMAIL_AND_PASSWORD,
        payload: { code: MISSING_TENANT_ID }
      });
    }
    return dispatch(actionCreators.signInWithEmailAndPassword({ ...data, tenantId, tenant }));
  },
  signInWithEmailAndPassword: (data) => ({
    type: actions.SIGN_IN_WITH_EMAIL_AND_PASSWORD,
    target: TARGETS.SIGN_IN_WITH_EMAIL_AND_PASSWORD,
    payload: data,
    service: FirebaseService.signInWithEmailAndPassword,
    injections: [
      withPostSuccess((dispatch, response) => {
        const { tenant } = data;
        const { stsTokenManager: tokenManager, email, displayName, uid } = response.data;
        setTokenHeader(tokenManager.accessToken);
        LocalStorage.setTokenManager({ ...tokenManager, email, displayName });
        posthog.identify(uid, { displayName, email, tenant });
        dispatch(AdminUserActions.getCurrentUser());
        dispatch(push(ROUTES.HOME.path));
      })
    ]
  }),
  refreshFirebaseToken: (token, callback) => ({
    type: actions.REFRESH_FIREBASE_TOKEN,
    payload: token,
    service: FirebaseService.refreshToken,
    injections: [
      withPostSuccess((_, response) => {
        const tokenManager = response.data;
        setTokenHeader(tokenManager.accessToken);
        LocalStorage.setTokenManager(tokenManager);
        if (callback) {
          callback();
        }
      }),
      withPostFailure((dispatch) => {
        setTokenHeader(null);
        LocalStorage.setTokenManager(null);
        dispatch(push(ROUTES.LOGIN.path));
      })
    ]
  }),
  logout: () => (dispatch) => {
    setTokenHeader(null);
    LocalStorage.setTokenManager(null);
    dispatch(push(ROUTES.HOME.path));
  }
};

export default actionCreators;
